import ChapterInfoFormContainer from './ChapterInfoFormContainer';

export default ChapterInfoFormContainer;
